module.exports = __webpack_public_path__ + "static/mq-2c5a49b05612875dfeaff8f8f6bb31fd.svg";